import * as React from "react"

const Spacer = ({className}) => (
  <div className={"spacer " + className}></div> 
) 
export default Spacer
